import BaseLayout from 'es6/components/memory-bank/layouts/base-layout';
import { t } from 'es6/services/localization';

const DivisionWidth = 135;

/**
 * The dimensions of the main area in the memory bank are from 723x730.
 * Starting at position (21, 0).
 */
const LABELS = [
  {
    text: t('completed-label'),
    x: 795,
    y: 305,
    class: 'label label-middle label-completed',
  },

  {
    text: t('memory-bank.zone-1-label'),
    x: 660,
    y: 305,
    class: 'label label-middle label-strong',
  },

  {
    text: t('memory-bank.not-ready-label'),
    x: 35,
    y: 10,
    dy: '0.5em',
    class: 'label label-not-ready',
  },

  {
    text: t('ready-label'),
    x: 35,
    y: 102,
    dy: '0.5em',
    class: 'label label-ready',
  },

  {
    text: '',
    x: 21,
    y: 312,
    dy: '0.5ex',
    class: 'label label-middle label-session-items-count',
  },

  {
    text: t('new-label'),
    x: 44,
    y: 338,
    class: 'label label-new',
  },

  {
    text: '20%',
    x: 189,
    y: 338,
    class: 'label label-middle label-percent',
  },

  {
    text: '40%',
    x: 324,
    y: 338,
    class: 'label label-middle label-percent',
  },

  {
    text: '60%',
    x: 459,
    y: 338,
    class: 'label label-middle label-percent',
  },

  {
    text: '80%',
    x: 594,
    y: 338,
    class: 'label label-middle label-percent',
  },

  {
    text: '100%',
    x: 729,
    y: 338,
    class: 'label label-middle label-percent',
  },
];

const SECTIONS = {
  notReady: {
    x: 44,
    y: 0,
    width: 817,
    height: 88,
  },

  ready: {
    x: 44,
    y: 92,
    width: 817,
    height: 226,
  },

  checkpoint1: {
    x: 590,
    width: DivisionWidth,
  },

  checkpoint2: {
    x: 725,
    width: DivisionWidth,
  },

  sessionItemsCount: {
    x: 1,
    y: 290,
    width: 40,
    height: 40,
  },
};

export default class Progress extends BaseLayout {
  hide() {
    super.hide();
    this.setSessionItemsCountLabel(null);
  }

  get labels() {
    return LABELS;
  }

  get sections() {
    return SECTIONS;
  }

  /**
   * Sets the text for session items label.
   *
   * param {Number} sessionItemsCount
   */
  setSessionItemsCountLabel(sessionItemsCount) {
    this._layoutContainer.select('.label-session-items-count').text(sessionItemsCount || '');
  }
}
